<template>
  <div>
    <div class="prospection">
        <div id="map" v-loading="loading"></div>
        <!-- <i class="settings fa-solid fa-sliders"></i> -->
        <div class="filtersProspectingMap">
          <div>
            <h4>Filtres</h4>
            <div>
              <div class="selectType">
                <el-select
                  style="flex: 0 0 45%;"
                  v-model="selectedThirdpartyType"
                  multiple
                  collapse-tags
                  placeholder="Type Dolibarr"
                  @change="changeFilters()">
                  <el-option
                    v-for="item in thirdpartyType"
                    :key="item.ref"
                    :label="item.libelle"
                    :value="item.ref">
                  </el-option>
                </el-select>
                <el-select
                  class="selectActivitePrincipale"
                  style="flex: 0 0 45%;"
                  v-model="selectedActivitePrincipale"
                  multiple
                  filterable
                  collapse-tags
                  placeholder="Catégories Gouv"
                  @change="changeFilters()">
                  <el-option
                    v-for="item in filterList"
                    :key="item.ref"
                    :label="item.libelle"
                    :value="item.ref"
                    style="max-width: 500px;">
                  </el-option>
                </el-select>
              </div>
              <el-slider
                v-model="radius"
                :step="1"
                show-stops
                :max="10"
                :min="1"
                @change="changeFilters()">
              </el-slider>
            </div>
          </div>
          <div>
            <h4>Mes listes de prospection</h4>
          </div>
        </div>
    </div> 
    <div class="help-panel">
      <div><span class="legend-color" style="background-color: #2AAD27;"></span> Source : Gouv</div>
      <div><span class="legend-color" style="background-color: #9C2BCB;"></span> Source : Dolibarr Client</div>
      <div><span class="legend-color" style="background-color: #FFD326;"></span> Source : Dolibarr Fournisseur & Client</div>
      <div><span class="legend-color" style="background-color: #2A81CB;"></span> Source : Dolibarr Fournisseur</div>
      <div><span class="legend-color" style="background-color: #7B7B7B;"></span> Source : Dolibarr Prospect</div>
    </div>
  </div>
</template>

<script>
import { get } from 'underscore';
import script from '../../../../script/script_prospection.js';
import scriptTiers from '../../../../script/script_tiers.js';
import L from "leaflet";
let map = L.Map
let userGeoMarker = L.Marker
let customIcon = new L.Icon({
    iconUrl:
      "https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-red.png",
    shadowUrl:
      "https://cdnjs.cloudflare.com/ajax/libs/leaflet/0.7.7/images/marker-shadow.png",
    iconSize: [25, 41],
    iconAnchor: [12, 41],
    popupAnchor: [1, -34],
    shadowSize: [41, 41],
})
export default {
  data() {
    return {
      loading: false,
      markersClients: [],
      markersClientsGouv: [],
      latitude: null, // Latitude will be stored here
      longitude: null, // Longitude will be stored here
      radius: 1, // Radius in kilometers
      selectedActivitePrincipale: [],
      selectedThirdpartyType: [
        "client",
        "prospect",
        "fournisseur"
      ],
      showHelp: false,
      thirdpartyType : [
        { ref: "client", libelle: "client"},
        { ref: "prospect", libelle: "prospect"},
        { ref: "fournisseur", libelle: "fournisseur"},
      ],
      filterList : [
        { ref: "A", libelle: "Agriculture et pêche"},
        { ref: "B", libelle: "Industries extractives"},
        { ref: "C", libelle: "Industrie manufacturière"},
        {
          ref: "D",
          libelle:
            "Production et distribution d'électricité, de gaz, de vapeur et d'air conditionné",
          
        },
        {
          ref: "E",
          libelle:
            "Production et distribution d'eau ; assainissement, gestion des déchets et dépollution",
          
        },
        { ref: "F", libelle: "Construction" },
        {
          ref: "G",
          libelle: "Commerce ; réparation d'automobiles et de motocycles",
          
        },
        { ref: "H", libelle: "Transports et entreposage" },
        { ref: "I", libelle: "Hébergement et restauration" },
        { ref: "J", libelle: "Information et communication" },
        {
          ref: "K",
          libelle: "Activités financières et d'assurance",
          
        },
        { ref: "L", libelle: "Activités immobilières" },
        {
          ref: "M",
          libelle: "Activités spécialisées, scientifiques et techniques",
          
        },
        {
          ref: "N",
          libelle: "Activités de services administratifs et de soutien",
          
        },
        { ref: "O", libelle: "Administration publique" },
        { ref: "P", libelle: "Enseignement" },
        { ref: "Q", libelle: "Santé humaine et action sociale" },
        {
          ref: "R",
          libelle: "Arts, spectacles et activités récréatives",
          
        },
        { ref: "S", libelle: "Autres activités de services" },
        {
          ref: "T",
          libelle:
            "Activités des ménages en tant qu'employeurs ; activités indifférenciées des ménages en tant que producteurs de biens et services pour usage propre",
          
        },
        { ref: "U", libelle: "Activités extra-territoriales" },
      ],
      tags : [],
      prospectionsLists : [],
    }
  },
  created(){
    this.getGeolocationUser()    
  },
  mounted:function(){
    this.verifyRight();
    map = L.map('map').setView([0, 0], 15);
    L.tileLayer('https://tile.openstreetmap.org/{z}/{x}/{y}.png', {
        maxZoom: 17,
        attribution: '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>'
    }).addTo(map);
  },
  methods: {
    verifyRight : script.verifyRight,
    toggleHelp() {
      this.showHelp = !this.showHelp;
    },
    getMarkerIcon(client,source){
      let markerColor = "green";
      if(source == "dolibarr"){
        let isClient = client.client === true;
        let isFournisseur = client.fournisseur === true;

        if (isFournisseur && !isClient) markerColor = "blue";
        else if (isClient && !isFournisseur) markerColor = "violet";
        else if (isClient && isFournisseur) markerColor = "gold";
        else markerColor = "grey"; // Prospect
      }
      return new L.Icon({
        iconUrl: `https://raw.githubusercontent.com/pointhi/leaflet-color-markers/master/img/marker-icon-2x-${markerColor}.png`,
        iconSize: [21, 34],
        iconAnchor: [10, 34],
        popupAnchor: [0, -34],
      });
    },
    getGeoloc : script.getGeoloc,
    async changeFilters() {
      this.loading = true;
      // Request the user's current position
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          // Success callback: update latitude and longitude
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          if (userGeoMarker) map.removeLayer(userGeoMarker)
          userGeoMarker = L.marker([this.latitude, this.longitude], { icon: customIcon }).addTo(map).bindPopup("Vous êtes ici")
          let clients = await this.getGeoloc(this.latitude,this.longitude,this.radius,this.selectedActivitePrincipale)
          clients.dolibarr = clients.dolibarr.filter(client => this.selectedThirdpartyType.includes(client.type))
          if(clients.dolibarr.length){
            for (let i = this.markersClients.length - 1; i >= 0; i--) {
              let marker = this.markersClients[i];
              let stillExists = clients.dolibarr.some(client =>
                marker.getLatLng().lat === client.latitude &&
                marker.getLatLng().lng === client.longitude
              );

              if (!stillExists) {
                map.removeLayer(marker);
                this.markersClients.splice(i, 1);
              }
            }
            clients.dolibarr.forEach(client => {
              let stillExists = this.markersClients.some(marker =>
                marker.getLatLng().lat === client.latitude &&
                marker.getLatLng().lng === client.longitude
              );

              if (!stillExists) {
                let customIconClients = this.getMarkerIcon(client,"dolibarr");
                let marker = L.marker([client.latitude, client.longitude], { icon: customIconClients }).addTo(map);
                marker.bindPopup(`<b>${client.name}</b><br>${client.address}`);
                this.markersClients.push(marker)
              }
            });
          }else{
            this.markersClients.forEach(marker => {
              map.removeLayer(marker);
            });
            this.markersClients = []
          }
          if(clients.gouv.length){
            for (let i = this.markersClientsGouv.length - 1; i >= 0; i--) {
              let marker = this.markersClientsGouv[i];
              let stillExists = clients.gouv.some(client =>
                marker.getLatLng().lat === client.latitude &&
                marker.getLatLng().lng === client.longitude
              );

              if (!stillExists) {
                map.removeLayer(marker);
                this.markersClientsGouv.splice(i, 1);
              }
            }
            clients.gouv.forEach(client => {
              let stillExists = this.markersClientsGouv.some(marker =>
                marker.getLatLng().lat === client.latitude &&
                marker.getLatLng().lng === client.longitude
              );

              if (!stillExists) {
                let customIconClients = this.getMarkerIcon(client,"gouv");
                let marker = L.marker([client.latitude, client.longitude], { icon: customIconClients }).addTo(map);
                marker.bindPopup(`<b>${client.name}</b><br>${client.address}`);
                this.markersClientsGouv.push(marker)
              }
            });
          }else{
            this.markersClientsGouv.forEach(marker => {
              map.removeLayer(marker);
            });
            this.markersClientsGouv = []
          }
          this.loading = false;
        },
        (error) => {
          this.errorMessage = `Error: ${error.message}`; // Show the error message
        },{
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    },
    async getGeolocationUser() {
      this.loading = true;
      // Request the user's current position
      navigator.geolocation.getCurrentPosition(
        async (position) => {
          // Success callback: update latitude and longitude
          this.latitude = position.coords.latitude;
          this.longitude = position.coords.longitude;
          if (userGeoMarker) map.removeLayer(userGeoMarker)
          userGeoMarker = L.marker([this.latitude, this.longitude], { icon: customIcon }).addTo(map).bindPopup("Vous êtes ici")
          map.setView([this.latitude, this.longitude], 15)
          let clients = await this.getGeoloc(this.latitude,this.longitude,this.radius,this.selectedActivitePrincipale)
          clients.dolibarr = clients.dolibarr.filter(client => this.selectedThirdpartyType.includes(client.type))
          if(clients.dolibarr.length){
            clients.dolibarr.forEach(client => {
              let customIconClients = this.getMarkerIcon(client,"dolibarr");
              let marker = L.marker([client.latitude, client.longitude], { icon: customIconClients }).addTo(map);
              marker.bindPopup(`<b>${client.name}</b><br>${client.address}`);
              this.markersClients.push(marker)
            });
          }
          if(clients.gouv.length){
            clients.gouv.forEach(client => {
              let customIconClients = this.getMarkerIcon(client,"gouv");
              let marker = L.marker([client.latitude, client.longitude], { icon: customIconClients }).addTo(map);
              marker.bindPopup(`<b>${client.name}</b><br>${client.address}`);
              this.markersClientsGouv.push(marker)
            });
          }
          this.loading = false;
        },
        (error) => {
          this.errorMessage = `Error: ${error.message}`; // Show the error message
        },{
          enableHighAccuracy: true,
          timeout: 5000,
          maximumAge: 0,
        }
      );
    },
    getProspectionListDet : scriptTiers.getProspectionListDet,
    getProspectionList : scriptTiers.getProspectionList,
    deleteToProspectionList : scriptTiers.deleteToProspectionList,
    addToProspectionList : scriptTiers.addToProspectionList,
    updateToProspectionList : scriptTiers.updateToProspectionList,
    createProspectionList : scriptTiers.createProspectionList,
    deleteProspectionList : scriptTiers.deleteProspectionList,
    updateProspectionList : scriptTiers.updateProspectionList,
  },
  components: {
    
  },
  computed:{
    info(){
      return this.$store.state.info
    },
  },
  watch:{
  }
  
}
</script>

<style scoped>
#map {
  height: 85vh;
  flex: 0 0 60%;
}
.prospection{
  display: flex;
  flex-direction: row
}

.help-panel {
  color: black;
  font-size: 14px;
  max-width: 60%;
  display: flex;
  justify-content: space-between;
}

.legend-color {
  display: inline-block;
  width: 12px;
  height: 12px;
  margin-right: 8px;
  border-radius: 2px;
  vertical-align: middle;
  flex-wrap: nowrap;
}

.settings{
    position: absolute;
    color: white;
    top: 15px;
    left: 56%;
    height: 40px;
    width: 40px;
    z-index: 999;
    font-size: 25px;
    background: grey;
    line-height: unset;
    border-radius: 50px;
}

.filtersProspectingMap{
  flex: 0 0 40%;
  padding: 2em;
}
.selectType{
  display: flex;
  justify-content: space-between;
}
</style>
